import { api } from "./api";
import { DeviceDailyStats } from "../types/dailyStats";
import { ApiResponse } from "../types/api";

export const dailyStatsService = {
  // 전체 기기 일별 통계 조회 (최신 날짜 순)
  getAll: async (): Promise<DeviceDailyStats[]> => {
    const response = await api.get<ApiResponse<DeviceDailyStats[]>>(
      "/api/admin/device-daily-stats",
      { withCredentials: true },
    );
    return response.data.data;
  },

  // 특정 기기(MAC 주소)의 통계만 조회
  getByDevice: async (address: string): Promise<DeviceDailyStats[]> => {
    const response = await api.get<ApiResponse<DeviceDailyStats[]>>(
      `/api/admin/device-daily-stats/device/${encodeURIComponent(address)}`,
      { withCredentials: true },
    );
    return response.data.data;
  },

  // 날짜 범위(from~to, "yyyy-MM-dd")로 조회
  getByDateRange: async (from: string, to: string): Promise<DeviceDailyStats[]> => {
    const response = await api.get<ApiResponse<DeviceDailyStats[]>>(
      "/api/admin/device-daily-stats/range",
      { params: { from, to }, withCredentials: true },
    );
    return response.data.data;
  },

  // 특정 기기의 모든 전화번호·날짜별 배터리 수신 기록 삭제 (회원·기기 등록 정보는 유지)
  deleteByDevice: async (address: string): Promise<number> => {
    const response = await api.delete<ApiResponse<number>>(
      `/api/admin/device-daily-stats/device/${encodeURIComponent(address)}`,
      { withCredentials: true },
    );
    return response.data.data;
  },
};
